/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID, MetedataLinkDto, ProduceStatusDto } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, identity, none, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { LetterDto, LetterMapper } from '../../letters';
import { JobOrderDetailsDto, JobOrderListDto, JobOrderListProduceDto } from './job-order.dto';
import { JobOrderDetailsMapper, JobOrderListMapper } from './job-order.mapper';
import { JobListFilterDto, JobListItemDto } from '../job.dto';
import { JobListFilterMapper, JobListItemMapper } from '../job.mapper';

@Injectable()
export class JobOrderRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAllByJobId(jobId: ID): Observable<JobOrderListDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/orders`, JobOrderListMapper);
  }

  getProduceStatus(jobId: ID): Observable<ProduceStatusDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/orders/produce-status`, identity());
  }

  getS3Link(jobId: ID): Observable<MetedataLinkDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/orders/complete-metadata`, identity());
  }

  produce(jobId: ID, produce: JobOrderListProduceDto): Observable<void> {
    return this.httpPost(`${this.bp}/jobs/${jobId}/orders/produce`, produce, identity(), none());
  }

  preview(jobId: ID, orderId: ID): Observable<LetterDto> {
    return this.httpGet(`${this.bp}/jobs/${jobId}/orders/${orderId}/preview`, LetterMapper);
  }

  update(jobId: ID, order: JobOrderDetailsDto): Observable<JobOrderDetailsDto> {
    return this.httpPut(`${this.bp}/jobs/${jobId}/orders/${order.orderId}`, order, JobOrderDetailsMapper);
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItemDto> {
    return this.createSlicedDataSourceGet(`${this.jad}/job-orders`,
                                          filter, JobListFilterMapper, arrayOf(JobListItemMapper));
  }
}
